import { Directive, Input, TemplateRef, ViewContainerRef, OnDestroy } from '@angular/core';
import { UserService } from '../user.service';
import { Subscription } from 'rxjs';

@Directive({
  selector: '[currHasProfilePermissions]'
})
export class HasProfilePermissionsDirective implements OnDestroy {
  private permissionKey: string;
  private subscription: Subscription;
  private elseTemplateRef: TemplateRef<any> | null = null;

  @Input()
  set currHasProfilePermissions(key: string) {
    this.permissionKey = key;
    this.updateView();
  }

  @Input()
  set currHasProfilePermissionsElse(templateRef: TemplateRef<any> | null) {
    this.elseTemplateRef = templateRef;
    this.updateView();
  }

  constructor(
    private templateRef: TemplateRef<any>,
    private viewContainer: ViewContainerRef,
    private userService: UserService
  ) {}

  private updateView() {
    if (!this.permissionKey) {
      this.showElse();
      return;
    }
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
    this.subscription = this.userService.hasCurrPermission(this.permissionKey)
      .subscribe(hasPermission => {
        this.viewContainer.clear();
        if (hasPermission) {
          this.viewContainer.createEmbeddedView(this.templateRef);
        } else if (this.elseTemplateRef) {
          this.viewContainer.createEmbeddedView(this.elseTemplateRef);
        }
      });
  }

  private showElse() {
    this.viewContainer.clear();
    if (this.elseTemplateRef) {
      this.viewContainer.createEmbeddedView(this.elseTemplateRef);
    }
  }

  ngOnDestroy() {
    if (this.subscription) {
      this.subscription.unsubscribe();
    }
  }
}
